import { Card, CardContent } from '@shared/components';
import { formatIsoDateOnlyShort } from '@/app/utils/formatDate';
import { formatVerbatimMoneyCurrency } from '@shared/utils/formatMoneyDisplay';
import type { RelatedRow } from '../../types/financials.types';

interface Props {
    rows: RelatedRow[];
    currency: string;
}

const headingId = 'related-transactions-heading';

export function RelatedTransactions({ rows, currency }: Props) {
    if (rows.length === 0) return null;

    return (
        <Card>
            <CardContent className="py-5">
                <section aria-labelledby={headingId} className="@container space-y-3">
                    <h3 id={headingId} className="text-lg font-semibold text-mp-foreground">
                        Related transactions
                    </h3>
                    <ul className="divide-y divide-mp-border text-sm">
                        {rows.map((row, index) => (
                            <li
                                key={`${row.date}-${index}`}
                                className="grid gap-1 py-3 @md:grid-cols-[110px_minmax(0,1fr)_auto] @md:gap-4"
                            >
                                <span className="text-mp-foreground">{formatIsoDateOnlyShort(row.date)}</span>
                                <span className="break-words text-mp-foreground">{row.description}</span>
                                <span className="font-bold text-mp-foreground @md:text-right">
                                    {formatVerbatimMoneyCurrency(row.amount, currency)}
                                </span>
                            </li>
                        ))}
                    </ul>
                </section>
            </CardContent>
        </Card>
    );
}
